import { downgradeComponent } from '@angular/upgrade/static';
import angular from 'angular';
import { GroupConfirmComponent } from './group-confirm.component';

export const ngxGroupConfirmModule = angular.module('ngxGroupConfirmModule', [])
	.directive('ngxGroupConfirm', downgradeComponent({ component: GroupConfirmComponent }))
	.name;
